import { Phone, CalendarCheck } from "lucide-react";
import { BUSINESS } from "@/lib/business";

export const MobileBottomBar = () => (
  <div
    data-testid="mobile-bottom-bar"
    className="md:hidden fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 border-t border-gold-soft/70 bg-white shadow-[0_-10px_30px_-15px_rgba(0,0,0,0.25)]"
  >
    <a
      href={`tel:${BUSINESS.phoneHref}`}
      data-testid="mobile-bar-call"
      className="flex items-center justify-center gap-2 py-4 font-sans font-semibold text-navy bg-white active:bg-surface"
    >
      <Phone className="w-5 h-5" /> Call
    </a>
    <a
      href={BUSINESS.bookingUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="mobile-bar-book"
      className="flex items-center justify-center gap-2 py-4 font-sans font-semibold text-white bg-gold active:bg-gold-dark"
    >
      <CalendarCheck className="w-5 h-5" /> Book
    </a>
  </div>
);
